import styled from "styled-components"
import {Label} from "@irati/ui/src/Typography"

const EndDate = styled(Label)`
  color: ${({theme}) => theme.colors.fontColor};
`

export default EndDate
